import * as React from "react";
import { FieldSet, DataTable, useGridState, IDataTableColumn } from "nsitools-react";
import { ETLCodes } from "../../../../../locales";
import { useTl, useApiService } from "../../../../../hooks";
import { FcbExportCentrePermissionDto, ExportApi } from "../../../../../api";
import { Checkbox } from "@blueprintjs/core";

export interface IExportCentrePermissionsGridProps {
  idExport: number;
  centres: FcbExportCentrePermissionDto[];
  loading: boolean;
}

export const ExportCentrePermissionsGrid: React.FunctionComponent<IExportCentrePermissionsGridProps> = ({
  idExport,
  centres = [],
  loading
}) => {
  const { t } = useTl();
  const api = useApiService(ExportApi);

  const [loadingCheckboxes ,setLoadingCheckboxes ] = React.useState(false);

  const tableState = useGridState<FcbExportCentrePermissionDto>({
    serverMode: false,
    enablePagination: false,
    enableFilter: false
  });

  const { setData } = tableState;

  React.useEffect(() => {
    setData(centres);
  }, [centres, setData]);

  const toggleSelection = React.useCallback(
    async (row: FcbExportCentrePermissionDto) => {
      setLoadingCheckboxes(true);
      row.selected = !row.selected;
      row.idexport = idExport;
      let nextData = [...centres];
      setData(nextData);
      try {
        await api.exportSaveCentrePermissions({ FcbExportCentrePermissionDto: row });
        setLoadingCheckboxes(false);
      } catch(e) {
        setLoadingCheckboxes(false);
        throw e;
      }
    },
    [api, centres, idExport, setData]
  );

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        fieldName: "checkboxes",
        autoFitContent: true,
        render: (item: FcbExportCentrePermissionDto) => (
          (<Checkbox
            checked={item.selected}
            onChange={e => {
              toggleSelection(item);
            }}
            disabled={loadingCheckboxes}
          />)
        )
      },
      {
        header: () => t(ETLCodes.Description),
        fieldName: "nom"
      }
    ],
    [loadingCheckboxes, t, toggleSelection]
  );

  return (
    <FieldSet title={t(ETLCodes.Centres)} collapsable defaultCollapsed>
      <DataTable dateFormat="dd-MM-yyyy" tableState={tableState} loading={loading} columns={columns} />
    </FieldSet>
  );
};
